import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import "rxjs/add/operator/toPromise";
import { LocalService } from "app/services/local.service";

@Injectable({
  providedIn: "root",
})
export class RoleBasedAdminService {
  apiUrl = "";
  // localStorage.getItem("client") &&
  // JSON.parse(localStorage.getItem("client")) &&
  // JSON.parse(localStorage.getItem("client"))["apiUrl"]
  //   ? JSON.parse(localStorage.getItem("client"))["apiUrl"]
  //   : environment.apiUrl;

  constructor(
    private http: HttpClient,
    public localService: LocalService,
  ) {
    if (localStorage.getItem("client")) {
      this.apiUrl = JSON.parse(localStorage.getItem("client"))["apiUrl"];
    } else {
      this.apiUrl = environment.apiUrl;
    }
  }

  roleList(data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "aggregator/listRole", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  deleteRole(data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "aggregator/deleteRole/" + data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  moduleList(search): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "aggregator/listModule", search, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  updateRole(data, roleId: any): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "aggregator/updateRole/" + roleId, data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  createRole(data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "aggregator/createRole", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  getAccessRole(data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "aggregator/getRoleAccess", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
}
